module.exports = __webpack_public_path__ + "static/media/university-limerick.a096bc18.png";